function GoogleIcon() {
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 110 110"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask height="110" id="mask0_99_4234" maskUnits="userSpaceOnUse" width="110" x="0" y="0">
        <path d="M110 0H0V110H110V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_99_4234)">
        <path
          d="M107.8 56.25C107.8 52.35 107.45 48.6001 106.8 44.9998H55V66.2748H84.5999C83.325 73.1498 79.4503 78.9749 73.6252 82.8749V96.675H91.4001C101.8 87.1 107.8 72.9997 107.8 56.25Z"
          fill="#4285F4"
        />
        <path
          d="M54.9998 110C69.8498 110 82.2996 105.075 91.3994 96.6753L73.6245 82.8753C68.6998 86.1753 62.3995 88.125 54.9998 88.125C40.6745 88.125 28.5498 78.45 24.2246 65.4502H5.84961V79.7001C14.8999 97.6752 33.4998 110 54.9998 110Z"
          fill="#34A853"
        />
        <path
          d="M24.2248 65.4502C23.1248 62.1502 22.5 58.6253 22.5 55.0002C22.5 51.3752 23.1248 47.8502 24.2248 44.5502V30.3003H5.8498C2.1252 37.7253 0 46.1254 0 55.0002C0 63.875 2.1252 72.2752 5.8498 79.7002L24.2248 65.4502Z"
          fill="#FBBC04"
        />
        <path
          d="M54.9998 21.8751C63.0744 21.8751 70.3245 24.6499 76.0247 30.0999L91.7998 14.3247C82.2749 5.44995 69.8245 0 54.9998 0C33.4998 0 14.8999 12.325 5.84961 30.3L24.2246 44.55C28.5498 31.5502 40.6745 21.8751 54.9998 21.8751Z"
          fill="#E94235"
        />
      </g>
    </svg>
  );
}

export default GoogleIcon;
